import { createContext, useContext, useLayoutEffect, useRef } from "react";

export const VideoDraftContext = createContext(null);

// State remains owned by each keyed editor; the coordinator only reads the
// latest committed render and invokes its normal persistence boundary.
export const useVideoDraft = (id, draft) => {
  const context = useContext(VideoDraftContext);
  const latest = useRef(draft);
  useLayoutEffect(() => { latest.current = draft; });
  const register = context?.register;
  const notify = context?.notify;
  useLayoutEffect(() => register?.(id, () => latest.current), [register, id]);
  useLayoutEffect(() => { notify?.(); }, [notify, draft.dirty, draft.pending, draft.saveBlockedReason]);
};

export const useVideoDraftExit = () => {
  const context = useContext(VideoDraftContext);
  return context?.requestExit || ((proceed) => proceed());
};

export const useHasVideoDraftProvider = () => Boolean(useContext(VideoDraftContext));
